export const layout = {
	ROW: "row",
	COLUMN: "column",
	GRID: "grid",
	ABSOLUTE: "absolute",
}

export const layoutDefaults = {
	
    viewportWidth: 1344,
	viewportHeight: 768,

	pageWidth: 1088,
	pageHeight: 612,
	
	pageMarginX: 128,
	pageMarginY: 78,
	
	tileCornerRadius: 8,

	columns: 12,
	rows: 12,
	gap: 12,
};
